import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Lock, Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: params.get("token"), password: pw }); setDone(true); }
    catch (err) { toast.error(err?.response?.data?.detail || "Reset failed. The link may have expired."); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="reset-password-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 p-8">
        {done ? (
          <div className="text-center">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-emerald-500 flex items-center justify-center"><CheckCircle2 className="h-7 w-7 text-white" /></div>
            <h1 className="font-heading text-2xl font-bold mt-4">Password updated</h1>
            <p className="text-slate-500 mt-2">You can now sign in with your new password.</p>
            <Button data-testid="reset-to-login" onClick={() => navigate("/login")} className="mt-6 w-full bg-blue-600 hover:bg-blue-700">Go to sign in</Button>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-bold">Set a new password</h1>
            <form onSubmit={submit} className="mt-5 space-y-3">
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input data-testid="reset-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" className="pl-9" />
              </div>
              <Button data-testid="reset-submit" type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 gap-2">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Update password
              </Button>
            </form>
            <Link to="/login" className="text-sm text-slate-400 hover:text-slate-600 block text-center mt-4">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
